module.exports = __webpack_public_path__ + "static/img/Kenny-Dougall.39bbee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kenny-Dougall.jpg
// module id = 9/3c
// module chunks = 0